import type { ComposerTranslation } from "vue-i18n";
import {
  setDetailMessageAsListItem,
  showNotificationError,
  showNotificationSuccess,
} from "~/core/utils/notifications";
import type { Sector } from "~/modules/sector/models/Sector.interface";
import type { SectorItemActionResult } from "~/modules/sector/models/SectorItemActionResult.interface";

/**
 * Show Action Status
 * @param data
 * @param successMessage
 * @param errorMessage
 * @param sector
 * @param t
 */
export function displayActionStatus(
  data: SectorItemActionResult[],
  successMessage: string,
  errorMessage: string,
  sector: Sector,
  t: ComposerTranslation,
) {
  const { notificationNumber: nbSuccess, msg: success } = getByStatus(
    data,
    true,
  );
  const { notificationNumber: nbError, msg: errors } = getByStatus(data, false);

  if (nbError) {
    showNotificationError(
      t(errorMessage, { sectorName: sector.name }, nbError),
      errors,
    );
  }

  if (nbSuccess > 0) {
    showNotificationSuccess(
      t(successMessage, { sectorName: sector.name }, nbSuccess),
      success,
    );
  }
}

function getByStatus(
  data: SectorItemActionResult[],
  success: boolean,
): { msg: string; notificationNumber: number } {
  const notificationsByStatus = data.filter((d) => d.success === success);

  const msg = notificationsByStatus
    .map((d) => d.name || "")
    .map(setDetailMessageAsListItem)
    .join("");

  return {
    msg,
    notificationNumber: notificationsByStatus.length,
  };
}
